<template>
  <div>
    <!-- ユーザー情報入力エリア -->
    <form>
      <div class="p-team-user-edit">
        <!-- 入力 | 選択リスト -->
        <ul class="p-team-user-edit-list">
          <!-- メールアドレス -->
          <li class="p-team-user-edit-list__item">
            <div class="c-input u-w500">
              <div class="c-input__title">メールアドレス（ログインID）</div>
              <input
                v-model="email"
                class="c-input__item"
                type="text"
                name="email"
                value=""
                placeholder="メールアドレスを入力してください"
                :readonly="isEdit"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /メールアドレス -->
          <!-- 初期パスワード -->
          <li class="p-team-user-edit-list__item p-team-user-edit-list__item--password">
            <template v-if="isEdit">
              <div class="c-checkbox">
                <div class="c-checkbox__title">パスワード初期化</div>
                <ul class="c-checkbox-list">
                  <li class="c-checkbox-list__item">
                    <label class="c-checkbox__label">
                      <input v-model="resetPassword" type="checkbox" name="resetPassword" />
                      <div class="c-checkbox__item">
                        <div class="c-checkbox__box"></div>
                        <div class="c-checkbox__box-label"></div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div class="c-input__text">更新するとランダムな初期パスワードを発行し、完了画面に一度だけ表示します。</div>
              </div>
            </template>
            <template v-else>
              <div class="c-input">
                <div class="c-input__title">初期パスワード</div>
                <div class="c-input__text">登録時にランダムな文字列で発行し、登録後に表示します。初回ログイン時に新しいパスワードへの変更が必要です。</div>
              </div>
            </template>
          </li>
          <!-- /初期パスワード -->
          <!-- 名前 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-input u-w500">
              <div class="c-input__title">名前</div>
              <input
                v-model="userName"
                class="c-input__item"
                type="text"
                name="userName"
                value=""
                placeholder="名前を入力してください"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /名前 -->
          <!-- 権限選択 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-radio">
              <div class="c-radio__title">権限</div>
              <ul class="c-radio-list">
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="userRole"
                      type="radio"
                      name="userRole"
                      value="2"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">サイト管理者</div>
                    </div>
                  </label>
                </li>
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="userRole"
                      type="radio"
                      name="userRole"
                      value="3"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">一般</div>
                    </div>
                  </label>
                </li>
              </ul>
              <div class="c-error">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /権限選択 -->
          <!-- 契約者 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-radio">
              <div class="c-radio__title">契約者</div>
              <ul class="c-radio-list">
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="isContractor"
                      type="radio"
                      name="isContractor"
                      value="0"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">一般</div>
                    </div>
                  </label>
                </li>
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="isContractor"
                      type="radio"
                      name="isContractor"
                      value="1"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">契約者</div>
                    </div>
                  </label>
                </li>
              </ul>
              <div class="c-error">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /契約者 -->
        </ul>
      </div>
      <!-- /入力 | 選択リスト -->
      <!-- ボタンエリア -->
      <div class="p-team-btns">
        <a class="c-btn c-btn--gray u-w320">
          <p class="c-btn__text">キャンセル</p>
        </a>
        <button
          class="c-btn c-btn--blue u-w320"
          :class="{ 'is-loading': isLoadingSaveBtn }"
          :disabled="isLoadingSaveBtn"
          type="button"
          name="add"
          value="add-user"
          @click="add()"
        >
          <p class="c-btn__text">{{ isEdit ? '変更する' : '追加する' }}</p>
        </button>
      </div>
      <!-- /ボタンエリア -->
    </form>
    <!-- /ユーザー情報入力エリア -->

    <!-- モーダルウィンドウ -->
    <div
      :class="[isCompleted ? 'is-active' : '']"
      class="c-modal c-modal--team-add-user"
    >
      <div class="c-modal__bg" @click="closeModal"></div>
      <div class="c-modal__content">
        <div class="c-modal__close" @click="closeModal">
          <div class="c-icon c-icon--white u-wh14">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use xlink:href="/assets/img/sprite.svg#close" />
            </svg>
          </div>
        </div>
        <div class="c-modal__inner">
          <div v-if="isEdit" class="c-modal__title">
            ユーザーが更新されました。<template v-if="initialPassword"><br />以下、内容をユーザーにご案内ください。</template>
          </div>
          <div v-else class="c-modal__title">
            ユーザーが追加されました。<br />以下、内容を追加したユーザーにご案内ください。
          </div>
          <div class="c-modal__data">
            <button
              class="c-btn c-btn--circle"
              type="button"
              name="clip"
              value="add-user"
              :class="{ 'is-active': copyStatus === 'copied' }"
              @click="onClipClick"
            >
              <div class="c-btn__text c-btn__text--balloon">
                {{ copyStatus === 'copied' ? 'コピーしました' : 'クリップボードにコピー' }}
              </div>
              <div class="c-icon-circle c-icon-circle--white u-wh40">
                <div
                  class="c-icon-circle__item c-icon-circle__item--gray-2 u-wh20"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clipboard" />
                  </svg>
                </div>
              </div>
            </button>
            <dl class="c-modal-list">
              <dt class="c-modal-list__label">名前</dt>
              <dd class="c-modal-list__value">{{ userName }}</dd>
              <dt class="c-modal-list__label">ログインID</dt>
              <dd class="c-modal-list__value">{{ email }}</dd>
              <template v-if="isEdit">
                <dd v-if="resetPassword" class="c-modal-list__warn">
                  ※パスワードは初期化されました。
                </dd>
              </template>
              <template v-if="initialPassword">
                <dt class="c-modal-list__label">初期パスワード</dt>
                <dd class="c-modal-list__value">{{ initialPassword }}</dd>
                <dd class="c-modal-list__warn">
                  ※パスワードは初回ログイン時に設定してください。
                </dd>
                <dd class="c-modal-list__warn">
                  ※この画面を閉じると初期パスワードは再表示できません。
                </dd>
                <dd v-if="copyStatus === 'failed'" class="c-modal-list__warn">
                  ※コピーできませんでした。初期パスワードを手で控えてください。
                </dd>
              </template>
            </dl>
          </div>
          <div class="c-modal__btns">
            <a
              class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14"
              @click="closeModal"
            >
              <p class="c-btn__text">ユーザーの一覧に戻る</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- /モーダルウィンドウ -->

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    account: {
      required: true,
      type: Object,
    },
    user: {
      required: false,
      type: Object
    }
  },
  data: function () {
    return {
      isCompleted: false,
      email: this.user?.login_id || null,
      userName: this.user?.user_name || null,
      userRole: this.user?.user_role || 3,
      isContractor: this.user?.contractor_flag || 0,
      resetPassword: false,
      initialPassword: null,
      // 'copied' | 'failed' | null
      copyStatus: null,
      errorMessage: '',
      isError: false,
      isLoadingSaveBtn: false,
    };
  },
  computed: {
    isEdit() {
      return this.user;
    }
  },
  methods: {
    add: function (_event) {
      // ローディング表示設定
      this.isLoadingSaveBtn = true;

      // ペイロード作成
      const data = {
        accountId: this.account.account_id,
        userId: this.user?.user_id,
        email: this.email,
        userName: this.userName,
        isContractor: this.isContractor,
        userRole: this.userRole,
        resetPassword: this.resetPassword
      };

      // ユーザーの新規登録処理実行
      axios
        .post("/api/accounts/" + this.account.account_id + "/users", data)
        .then((res) => {
          this.initialPassword = res.data.initialPassword;
          this.copyStatus = null;
          this.isCompleted = true;
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'ユーザーの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },
    backToUserList: function() {
      location.href = '/coins-admin/account/' + this.account.account_id + '/users';
    },
    // 初期パスワードは再表示できないため、コピーしていなければ閉じる前に確かめる
    confirmLeave: function () {
      if (!this.initialPassword || this.copyStatus === 'copied') {
        return true;
      }
      return window.confirm('初期パスワードを控えましたか？\nこの画面を閉じると再表示できません。');
    },
    closeModal: function (_event) {
      if (!this.confirmLeave()) {
        return;
      }
      this.isCompleted = false;
      this.backToUserList();
    },
    onClipClick: function (_event) {

      // クリップ文字列変数を初期化
      let text = "名前 " + this.userName + "\n" + "ログインID " + this.email + "\n";
      if (this.initialPassword) {
        text += "初期パスワード " + this.initialPassword + "\n";
      }

      this.$copyText(text).then(
        () => {
          this.copyStatus = 'copied';
        },
        () => {
          this.copyStatus = 'failed';
        }
      );
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },
};
</script>
